import { ITicketTypes } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/types";
import { selectTicketTypes } from "app/redux/selector";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ticketGroupsActions } from "../../Tickets/redux/slice";
import { PlanningViewBy } from "../types";
import AddTaskModal from "../../../components/AddTaskModalComponent/AddTaskModal";
import CreateSprint from "app/containers/Features/containers/Sprints/container/CreateSprint";
import AddReleaseModal from "../../../components/AddReleaseModal";
import AddComponentModal from "app/containers/Features/containers/TeamSettings/container/Projects/container/ProjectComponent/ComponentModal";

interface Props {
  activeModal: PlanningViewBy | null;
  onClose: () => void;
  projectId: string;
}

const getStoryTicketTypeId = (ticketTypes: ITicketTypes[]) =>
  ticketTypes?.find(
    (type) =>
      type.icon?.toLowerCase() === "story" ||
      type.name?.toLowerCase().includes("story"),
  )?._id;

const DEFAULT_EPIC_COLOR = "#27AE60";

const getEpicTicketTypeId = (ticketTypes: ITicketTypes[]) =>
  ticketTypes?.find(
    (type) =>
      type.icon?.toLowerCase() === "epic" ||
      type.name?.toLowerCase().includes("epic"),
  )?._id;

const PlanningModals: React.FC<Props> = ({
  activeModal,
  onClose,
  projectId,
}) => {
  const dispatch = useDispatch();
  const ticketTypes = useSelector(selectTicketTypes);

  useEffect(() => {
    if (activeModal !== PlanningViewBy.STORIES) return;

    const storyTypeId = getStoryTicketTypeId(ticketTypes);
    dispatch(ticketGroupsActions.clearCreateTicket());
    if (storyTypeId) {
      dispatch(
        ticketGroupsActions.setTicketFormValue({
          name: "type",
          value: storyTypeId,
        }),
      );
    }
  }, [activeModal, dispatch, ticketTypes]);

  useEffect(() => {
    if (activeModal !== PlanningViewBy.EPICS) return;
    const epicTypeId = getEpicTicketTypeId(ticketTypes);
    dispatch(ticketGroupsActions.clearCreateTicket());
    dispatch(
      ticketGroupsActions.setTicketFormValue({
        name: "color",
        value: DEFAULT_EPIC_COLOR,
      }),
    );
    if (epicTypeId) {
      dispatch(
        ticketGroupsActions.setTicketFormValue({
          name: "type",
          value: epicTypeId,
        }),
      );
    }
  }, [activeModal, dispatch, ticketTypes]);
  

  switch (activeModal) {
    case PlanningViewBy.COMPONENTS:
      return <AddComponentModal onClose={onClose} projectId={projectId} />;
    case PlanningViewBy.EPICS:
      return (
        <AddTaskModal
          title="Add new epic"
          onClose={onClose}
          isAddEpicModal
        />
      );
    case PlanningViewBy.SPRINTS:
      return <CreateSprint onClose={onClose} />;
    case PlanningViewBy.STORIES:
      return <AddTaskModal title="Add new story" onClose={onClose} />;
    case PlanningViewBy.NEXT_RELEASES:
      return <AddReleaseModal onClose={onClose} />;
    case PlanningViewBy.PAST_RELEASES:
      return <AddReleaseModal onClose={onClose} />;

    default:
      return null;
  }
};

export default PlanningModals;
